import axios from "axios";
import LocalStorage from "../../localStorage";
import {loggedOut} from "../auth";

export const GET_SHOOT_TYPE_REQUEST = 'GET_SHOOT_TYPE_REQUEST';
export const GET_SHOOT_TYPE_SUCCESS = 'GET_SHOOT_TYPE_SUCCESS';
export const GET_SHOOT_TYPE_FAILURE = 'GET_SHOOT_TYPE_FAILURE';

const localStorageService = LocalStorage.getService();

export const getShootTypeRequest = () => {
    return {type: GET_SHOOT_TYPE_REQUEST}
};

export const getShootTypeSuccess = (shoot_type = {}) => {
    return {type: GET_SHOOT_TYPE_SUCCESS, shoot_type}
};

export const getShootTypeFailure = (error) => {
    return {type: GET_SHOOT_TYPE_FAILURE, error}
};

export const startGetShootType = () => {
    console.log('Start startGetShootType');
    let token = localStorageService.getAccessToken();
    return (dispatch) => {
        dispatch(getShootTypeRequest());
        return axios({
                url: `${process.env.REACT_APP_API_ROOTURL}/shoot_type/list?key=${process.env.REACT_APP_SERVICE_ACCOUNT_KEY}`,
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    Authorization: 'Bearer ' + token,
                },
                data: JSON.stringify({}),
            }
        )
            .then(function (response) {
                if (response.status === 200 && response.data !== null) {
                    console.log("Response shoot_type search ", response.data);
                    dispatch(getShootTypeSuccess(response.data));

                }
            })
            .catch(function (error) {
                console.log(error);
                if(error.response.status === 401) dispatch(loggedOut());
                dispatch(getShootTypeFailure(error));
            });
    };
};
